import { render, staticRenderFns } from "./BackToCalendar.vue?vue&type=template&id=412d78aa&scoped=true"
import script from "./BackToCalendar.vue?vue&type=script&lang=js"
export * from "./BackToCalendar.vue?vue&type=script&lang=js"
import style0 from "./BackToCalendar.vue?vue&type=style&index=0&id=412d78aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d78aa",
  null
  
)

export default component.exports